module.exports = __webpack_public_path__ + "image/qr_assistant_11b13.jpg";